<template>
    <v-container fluid>
        <v-card>
            <v-card-title>
                {{ pageTitle }}
            </v-card-title>

            <component :is="table" :filter="filter" />
        </v-card>
    </v-container>
</template>

<script>
    export default {
        props: [
            'filter',
            'tablePromise',
            'pageTitle'
        ],
        components: {
            defaultComponent: () => import('../components/DefaultComponent.vue')
        },

        data() {
            return {
                table: 'defaultComponent',
            }
        },

        watch: {
            tablePromise: {
                immediate: true,
                async handler() {
                    this.table = await this.tablePromise;
                }
            }
        }
    };
</script>
